function Hr({ spacing }) {
    return <hr className={`h-px bg-expo-thin border-0 ${spacing ? 'my-6' : 'mb-2'}`} />
}

export default Hr
